export const validarCambioDeDatos = (dataOriginal, dataModificada) => {
  if (!dataOriginal || !dataModificada) return null;

  const keysCambioDatos = [
    "fecha_hora",
    "direccion",
    "plate",
    "documento_infractor",
    "documento_titular",
    "nombre_titular",
    "apellido_titular",
    "correo_electronico_titular",
    "correo_electronico_cortesia",
    "razonSocial",
    "direccion_titular",
    "barrio_sigemi",
    "provincia",
    "localidad",
    "codigo_postal",
    "longitud",
    "latitud",
    "cuit",
    "marca_vehiculo",
    "modelo_vehiculo",
    "dependencia",
    "numero_acta",
    "articulos",
  ];

  const valoresCambiados = keysCambioDatos.filter(
    (key) => dataOriginal[key] !== dataModificada[key]
  );

  return valoresCambiados;
};
